import Reflux from 'reflux';
import ItemSetData from 'shared/data/ItemSet';
import EventData from 'shared/data/Event';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

const async = { asyncResult: true };
const sync = { sync: true };

const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);
const syncReadOnlyCfg = readOnlyHelper.actionConfigFactory(sync);
const readOnlyCfg = readOnlyHelper.actionConfigFactory();

const CuesheetCellActions = Reflux.createActions({
  selectItemCell: readOnlyCfg,
  selectTimeCell: readOnlyCfg,
  startEditingItemCell: readOnlyCfg,
  cancelEditing: readOnlyCfg,
  clearPastableCellsBuffer: {},
  startEditingDataCell: readOnlyCfg,
  /**
   * This needs to be sync, because if it's not key events are lost, and the
   * first letter isn't placed into the textarea
   */
  startEditingSelectedCell: syncReadOnlyCfg,
  selectFeaturedCell: readOnlyCfg,
  startEditingFeaturedCell: readOnlyCfg,
  selectDataCell: readOnlyCfg,
  showSelectedCellHistory: {},
  showCellHistory: {},
  clearSelectedCell: readOnlyCfg,
  refocusCell: readOnlyCfg,
  addSelectedCellsToPasteBuffer: readOnlyCfg,
  addSelectedCellsToCutBuffer: readOnlyCfg,
  pasteCellsBuffer: readOnlyCfg,
  saveItemNumber: readOnlyCfg,
  saveDataCellChanges: readOnlyCfg,
  saveItemTimeField: readOnlyCfg,
  saveItemTimeFields: readOnlyCfg,
  selectHeaderCell: readOnlyCfg,
  startEditingHeaderCell: readOnlyCfg,
  saveHeaderCellChanges: readOnlyCfg,
  saveMultipleDataCellChanges: readOnlyCfg,
  saveMultipleDataCellChangesPersistent: asyncReadOnlyCfg,
  saveColumnChangesPersistent: asyncReadOnlyCfg,
  saveSelectedCellFormat: readOnlyCfg,
  saveSelectedCellTextWithLink: readOnlyCfg,
  saveSelectedCellTextWithImage: readOnlyCfg,
  saveDataCellTextWithIds: readOnlyCfg,
  saveItemFieldWithIds: readOnlyCfg,
  saveSelectedCellTextWithTimeStamp: readOnlyCfg,
  setFullScreenFeaturedCell: readOnlyCfg,
  updateSelectedCellImage: readOnlyCfg,
  showCuesheetModal: readOnlyCfg,
  addCellAsset: readOnlyCfg,
  uploadCellAsset: asyncReadOnlyCfg,
  toggleTextSizeGrow: readOnlyCfg,
  toggleTextSizeShrink: readOnlyCfg,
  toggleCellForeColor: readOnlyCfg,
  toggleCellBackColor: readOnlyCfg,
  saveFeaturedZoom: readOnlyCfg,
  openDoc: readOnlyCfg,
  revertToLastSuccessfulCellState: {},
});

CuesheetCellActions.saveMultipleDataCellChangesPersistent.listenAndPromise(
  ItemSetData.updateMultipleItemRowCells,
);

CuesheetCellActions.uploadCellAsset.listen((teamId, eventId, title, file) => {
  EventData.uploadAsset(teamId, eventId, file)
    .then(({ url, s3Key }) => {
      CuesheetCellActions.uploadCellAsset.completed(title, url, s3Key);
    })
    .catch(() => {
      CuesheetCellActions.uploadCellAsset.failed();
    });
});

export default CuesheetCellActions;
